export default __webpack_public_path__ + "static/media/Frame 3215mobile.15cc9e6a.png";